import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalBody } from 'reactstrap';
import { close_success_modal } from '../../../slices/Success_Modal/reducer';

const SuccessModal = () => {
    


 

    const { open_modal , modal_message } = useSelector((state)=> state.Success_Modal);
    const dispatch = useDispatch();

  return (
    <>
       {/* <Button color="primary"  data-bs-target="#success-Modal" onClick={() => tog_successMessage()} >Success Modal</Button> */}
       {/* Success Message */}

       <Modal id="success-Modal" tabIndex="-1" isOpen={open_modal}  centered>
                <ModalBody className='text-center p-5'>
                    <div className="text-end">
                        <button type="button" onClick={() => { dispatch(close_success_modal()) }} className="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="mt-2">
                        <i className='ri-thumb-up-line'></i>
                        {/* <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover"
                            style={{ width: "150px", height: "150px" }}>
                        </lord-icon> */}
                        
                        <h4 className="mb-3 mt-4">{modal_message}</h4>
                        <p className="text-muted fs-15 mb-4"></p>
                        {/*<div className="hstack gap-2 justify-content-center">
                            <button className="btn btn-primary"></button>
                             <button className="btn btn-soft-success"><i className="ri-links-line align-bottom"></i> Copy tracking link</button>
                        </div> */}
                    </div>
                </ModalBody>
            </Modal>
    </>
  )
}

export default SuccessModal
